import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/RepairabilityIndex/repairabilityIndex"
    ).then((module) => ({ default: module.RepairabilityIndex }))
);
